<section class="mealset-section">
  <header>
    <h2>{{title}}</h2>
    <span class="rule" *ngIf="rule">{{rule}}</span>
  </header>
  <ng-content></ng-content>
</section>
